"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseNormalizedService = void 0;
const base_service_1 = require("./base-service");
const typeorm_1 = require("typeorm/browser");
const layouts_1 = require("../data-ui/layouts");
const data_ui_1 = require("../data-ui");
const column_numeric_transformer_1 = require("../transformers/column-numeric-transformer");
class BaseNormalizedService extends base_service_1.BaseService {
}
__decorate([
    data_ui_1.DataUi.Override({ label: 'Assembly time (minutes)' }),
    (0, typeorm_1.Column)('double precision', {
        name: 'vor__c',
        nullable: true,
    }),
    __metadata("design:type", Number)
], BaseNormalizedService.prototype, "assemblyTime", void 0);
__decorate([
    data_ui_1.DataUi.EnumValuesFromPicklist('Transporter', true),
    (0, typeorm_1.Column)('character varying', {
        name: 'transporter__c',
        length: 255,
        nullable: true,
    }),
    __metadata("design:type", String)
], BaseNormalizedService.prototype, "transporter", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'HwO A' }),
    data_ui_1.DataUi.EnumValuesFromPicklist('HwO_A', true),
    (0, typeorm_1.Column)('character varying', {
        name: 'hwo_a__c',
        nullable: true,
        length: 4099,
    }),
    __metadata("design:type", String)
], BaseNormalizedService.prototype, "hwoA", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'HwO B1' }),
    data_ui_1.DataUi.EnumValuesFromPicklist('HwO_B1', true),
    (0, typeorm_1.Column)('character varying', {
        name: 'hwo_b1__c',
        nullable: true,
        length: 4099,
    }),
    __metadata("design:type", String)
], BaseNormalizedService.prototype, "hwoB1", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'HwO B2' }),
    data_ui_1.DataUi.EnumValuesFromPicklist('HwO_B2', true),
    (0, typeorm_1.Column)('character varying', {
        name: 'hwo_b2__c',
        nullable: true,
        length: 4099,
    }),
    __metadata("design:type", String)
], BaseNormalizedService.prototype, "hwoB2", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Nicht HwO' }),
    data_ui_1.DataUi.EnumValuesFromPicklist('nicht_HwO', true),
    (0, typeorm_1.Column)('character varying', {
        name: 'kein_hwo__c',
        nullable: true,
        length: 4099,
    }),
    __metadata("design:type", String)
], BaseNormalizedService.prototype, "noHwo", void 0);
__decorate([
    data_ui_1.DataUi.Override({ emptyToNull: true }),
    (0, typeorm_1.Column)({
        name: 'minimum_quantity__c',
        nullable: true,
        type: 'numeric',
        precision: 18,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], BaseNormalizedService.prototype, "minimumQuantity", void 0);
__decorate([
    data_ui_1.DataUi.Override({ emptyToNull: true }),
    (0, typeorm_1.Column)({
        name: 'maximum_quantity__c',
        nullable: true,
        type: 'numeric',
        precision: 18,
        scale: 6,
        transformer: new column_numeric_transformer_1.ColumnNumericTransformer(),
    }),
    __metadata("design:type", Number)
], BaseNormalizedService.prototype, "maximumQuantity", void 0);
__decorate([
    data_ui_1.DataUi.EnumValuesFromPicklist('Unit_measure'),
    (0, typeorm_1.Column)('character varying', {
        name: 'unit_measure__c',
        nullable: true,
        length: 255,
    }),
    __metadata("design:type", String)
], BaseNormalizedService.prototype, "unitMeasure", void 0);
__decorate([
    data_ui_1.DataUi.Override({ length: 32768 }),
    (0, typeorm_1.Column)('text', {
        name: 'customer_needs__c',
        nullable: true,
    }),
    __metadata("design:type", String)
], BaseNormalizedService.prototype, "customerNeeds", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Lagerplatz (m3)' }),
    (0, typeorm_1.Column)('double precision', {
        name: 'storage__c',
        nullable: true,
    }),
    __metadata("design:type", Number)
], BaseNormalizedService.prototype, "storage", void 0);
__decorate([
    data_ui_1.DataUi.Override({ emptyToNull: true }),
    (0, typeorm_1.Column)('character varying', {
        name: 'tech_support_url__c',
        length: 255,
        nullable: true,
    }),
    __metadata("design:type", String)
], BaseNormalizedService.prototype, "techSupportUrl", void 0);
__decorate([
    data_ui_1.DataUi.Override({ label: 'Service Type (Installation, Materialkosten)' }),
    data_ui_1.DataUi.EnumValuesFromPicklist('service_type'),
    (0, typeorm_1.Column)('varchar', {
        name: 'planning_service__c',
        length: 255,
    }),
    __metadata("design:type", String)
], BaseNormalizedService.prototype, "serviceType", void 0);
__decorate([
    data_ui_1.DataUi.EnumValuesFromPicklist('One_or_many', false, 'many'),
    (0, typeorm_1.Column)('character varying', {
        name: 'ein_oder_mehrere__c',
        nullable: true,
        length: 255,
    }),
    __metadata("design:type", String)
], BaseNormalizedService.prototype, "oneOrMany", void 0);
__decorate([
    (0, typeorm_1.Column)('character varying', {
        name: 'service_group_name_de__c',
        length: 100,
        nullable: true,
    }),
    __metadata("design:type", String)
], BaseNormalizedService.prototype, "serviceGroupNameDe", void 0);
__decorate([
    data_ui_1.DataUi.EnumValuesFromPicklist('material', true),
    (0, typeorm_1.Column)('character varying', {
        name: 'material__c',
        nullable: true,
        length: 4099,
    }),
    __metadata("design:type", String)
], BaseNormalizedService.prototype, "material", void 0);
__decorate([
    data_ui_1.DataUi.EnumValuesFromPicklist('tools', true),
    (0, typeorm_1.Column)('character varying', {
        name: 'werkzeug__c',
        nullable: true,
        length: 4099,
    }),
    __metadata("design:type", String)
], BaseNormalizedService.prototype, "tools", void 0);
__decorate([
    data_ui_1.DataUi.LayoutConfig(layouts_1.HIDE_IN_FORM, layouts_1.HIDE_IN_TABLE),
    data_ui_1.DataUi.EnumValuesFromPicklist('project_sequence'),
    (0, typeorm_1.Column)('character varying', {
        name: 'project_default_sequence__c',
        length: 255,
        nullable: true,
    }),
    __metadata("design:type", String)
], BaseNormalizedService.prototype, "projectDefaultSequence", void 0);
exports.BaseNormalizedService = BaseNormalizedService;
//# sourceMappingURL=base-normalized-service.js.map